/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { SendGiftResponse, SendGiftVars } from '../openapi-types.gen.js';

export type { SendGiftResponse, SendGiftVars } from '../openapi-types.gen.js';

export const useSendGift = createMutationHook<SendGiftVars, SendGiftResponse, unknown>({
  specName: 'useSendGift',
  path: '/v1/gifts/send',
  method: 'POST',
  resolveUrl: (vars: SendGiftVars) => `/v1/gifts/send`,
  buildBody: (vars: SendGiftVars) => ({ recipientPlatform: vars.recipientPlatform, recipientHandle: vars.recipientHandle, asset: vars.asset, message: vars.message, anonymous: vars.anonymous }),
  parseResponse: (raw: unknown): SendGiftResponse => raw as SendGiftResponse,
  
  
  
});
